import styled from 'styled-components';

export const Container = styled.div<{
  selected;
  fullWidth;
  isError;
}>`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.pxToRem(5)};
  background-color: ${({ theme, isError }) => (isError ? '#f8f1f1' : theme.colours.whiteSolid)};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : '288px')};
  height: 80px;
`;

export const FileInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  min-width: 0;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(20)};
  padding-right: ${({ theme }) => theme.spacing(8)};
`;

export const CategoryTextContainer = styled.p`
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
`;

export const InfoContainer = styled.div`
  margin-left: ${({ theme }) => theme.spacing(20)};
  min-width: 0;
  max-width: 100%;
`;

export const Name = styled.p`
  color: ${({ theme }) => theme.colours.crowberryBlue};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: ${({ theme }) => theme.pxToRem(16)};
  font-weight: ${({ theme }) => theme.typography.fontWeight.regular};
  letter-spacing: 0;
  line-height: 1.5;
  user-select: none;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
`;

export const SizeCategoryContainer = styled.div`
  color: ${({ theme }) => theme.colours.agedGray};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: ${({ theme }) => theme.pxToRem(12)};
  font-weight: ${({ theme }) => theme.typography.fontWeight.regular};
  letter-spacing: 0;
  line-height: 1.5;
  user-select: none;
`;

export const ErrorMessage = styled.p`
  font-size: ${({ theme }) => theme.pxToRem(10)};
  line-height: 1.4;
  color: ${({ theme }) => theme.colours.redRampage};
`;

export const StatusMessage = styled.p`
  font-size: ${({ theme }) => theme.pxToRem(10)};
  line-height: 1.4;
  color: ${({ theme }) => theme.colours.agedGray};
`;

export const ActionContainer = styled.div<{ isSelected; isInProgress }>`
  display: flex;
  flex-direction: column;
  flex: 0 0 ${({ theme }) => theme.pxToRem(54)};
  align-items: ${({ isInProgress }) => (isInProgress ? 'center' : 'flex-end')};
  justify-content: ${({ isInProgress }) => (isInProgress ? 'center' : 'flex-start')};
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme, isInProgress }) => (isInProgress ? '0' : theme.spacing(8))}
    ${({ theme }) => theme.spacing(12)} 0 ${({ theme }) => theme.spacing(8)};
  box-sizing: border-box;

  .spinner {
    border-width: 3px;
    width: 18px;
    height: 18px;
    z-index: auto;
  }

  .close-box {
    display: flex;
    padding: ${({ theme }) => theme.spacing(4)};
  }

  .select-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15px;
    height: 15px;
    border-radius: ${({ theme }) => theme.pxToRem(3)};
    border: 1px solid ${({ theme }) => theme.colours.crowberryBlue};
    background-color: ${({ theme, isSelected }) =>
      isSelected ? theme.colours.crowberryBlue : theme.colours.white};
    margin: ${({ theme }) => theme.spacing(2)};
  }
`;

export const DateInfo = styled.span`
  white-space: nowrap;
`;
